import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VSimpleTable, {
    staticClass: "elevation-0 mb-4",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            _c("thead", [
              _c("tr", [
                _c("th", { staticClass: "text-center" }),
                _c("th", { staticClass: "text-left" }, [_vm._v("COMPETÊNCIA")]),
                _c("th", { staticClass: "text-center" }, [_vm._v("RESULTADO")]),
                _c("th", { staticClass: "text-center" }, [
                  _vm._v("RESULTADO MÁXIMO"),
                ]),
              ]),
            ]),
            _c(
              "tbody",
              [
                _vm._l(
                  _vm.sortIndicacoesTalento(_vm.indicacoesTalento),
                  function (indicacao) {
                    return _c("tr", { key: indicacao.id }, [
                      _c(
                        "td",
                        { attrs: { width: "5%" } },
                        [
                          _c(
                            VIcon,
                            { attrs: { color: "yellow darken-3" } },
                            [_vm._v("emoji_events")]
                          ),
                        ],
                        1
                      ),
                      _c("td", [
                        _c(
                          "span",
                          { staticClass: "grey--text text--darken-2" },
                          [_vm._v(_vm._s(indicacao.competencia.nome))]
                        ),
                      ]),
                      _c(
                        "td",
                        { staticClass: "text-center", attrs: { width: "10%" } },
                        [
                          _c("span", { staticClass: "success--text" }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("decimal")(indicacao.notaAgrupada)
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        { staticClass: "text-center", attrs: { width: "10%" } },
                        [
                          _c(
                            "span",
                            { staticClass: "grey--text text--darken-2" },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("decimal")(indicacao.notaMaxima)
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ])
                  }
                ),
                _vm._l(
                  _vm.sortIndicacoesDesenvolvimento(
                    _vm.indicacoesDesenvolvimento
                  ),
                  function (indicacao) {
                    return _c("tr", { key: indicacao.id }, [
                      _c(
                        "td",
                        { attrs: { width: "5%" } },
                        [
                          _c(VIcon, { attrs: { color: "error" } }, [
                            _vm._v("trending_up"),
                          ]),
                        ],
                        1
                      ),
                      _c("td", [
                        _c(
                          "span",
                          { staticClass: "grey--text text--darken-2" },
                          [_vm._v(_vm._s(indicacao.competencia.nome))]
                        ),
                      ]),
                      _c(
                        "td",
                        { staticClass: "text-center", attrs: { width: "10%" } },
                        [
                          _c("span", { staticClass: "error--text" }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("decimal")(indicacao.notaAgrupada)
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        { staticClass: "text-center", attrs: { width: "10%" } },
                        [
                          _c(
                            "span",
                            { staticClass: "grey--text text--darken-2" },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("decimal")(indicacao.notaMaxima)
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ])
                  }
                ),
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "text-center", attrs: { colspan: "6" } },
                    [
                      _c(
                        VRow,
                        { staticClass: "justify-center" },
                        [
                          _c(
                            VCol,
                            [
                              _c(
                                VIcon,
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "yellow darken-3" },
                                },
                                [_vm._v(" emoji_events ")]
                              ),
                              _vm._v(" Indicação de Talento "),
                              _c(
                                VIcon,
                                {
                                  staticClass: "ml-8 mr-2",
                                  attrs: { color: "error" },
                                },
                                [_vm._v(" trending_up ")]
                              ),
                              _vm._v(" Indicação de Desenvolvimento "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }